import axios from 'axios'

export default {
    namespaced: true,
    state: {
        costs: [],
    },
    mutations: {
        CLEAR_DATA(state) {
            state.costs = []
        },
        FETCH_COSTS(state, payload) {
            state.costs = payload
        },
        ADD_COSTS(state, payload) {
            const index = state.costs.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.costs[index], payload)
            } else {
                state.costs.push(payload)
            }
        },
        EDIT_COSTS(state, payload) {
            const index = state.costs.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.costs[index], payload)
            }
        },
        DEL_COSTS(state, payload) {
            const index = state.costs.findIndex(
                item => item.id === payload
            )
            if (index !== -1) {
                state.costs.splice(index, 1)
            }
        },
    },
    actions: {
        fetch({commit, dispatch, state}) {
            return new Promise((resolve, reject) => {
                if (state.costs.length) {
                    resolve()
                } else {
                    axios.get(
                        '/api/root/executor-costs'
                    ).then(({data}) => {
                        commit('FETCH_COSTS', data.data)
                        resolve()
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        add({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/executor-costs',
                    data
                ).then(({data}) => {
                    commit('ADD_COSTS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/executor-costs/' + data.id,
                    data
                ).then(({data}) => {
                    commit('EDIT_COSTS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch, commit}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/executor-costs/' + itemId,
                ).then(() => {
                    commit('DEL_COSTS', itemId)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}
